import createValidator from 'typecheck.macro';
import { makeExperimentWithData } from '../ExperimentContext/types';
import { useExperiment } from '../ExperimentContext/useExperiment';

export const HomepageTilesExperiment = makeExperimentWithData(
  'onion-458-homepage-tiles',
  createValidator<undefined | { variant: number }>(),
);

export const useHomepageTiles = () => {
  const experiment = useExperiment(HomepageTilesExperiment);
  return experiment.data?.variant === 1;
};
